import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=57c787e8"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"
import style0 from "./forgot_password.vue?vue&type=style&index=0&id=57c787e8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c787e8')) {
      api.createRecord('57c787e8', component.options)
    } else {
      api.reload('57c787e8', component.options)
    }
    module.hot.accept("./forgot_password.vue?vue&type=template&id=57c787e8", function () {
      api.rerender('57c787e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/account/forgot_password.vue"
export default component.exports